module.exports = __webpack_public_path__ + "img/WD_ZY.d364b829.png";